import React, { useContext } from 'react';
import { guide } from '@ignitesales/diana-utils';
import { ThemeProvider } from 'styled-components';

const defaultValue = {
  modalCloseBtn: (
    <i className="fa fa-times-circle" role="img" aria-label="Close" />
  )
};
const AppContext = React.createContext({});
const {ColorContextProvider, ColorContext} = guide;

const AppProvider = ({ value, children }) => {
  return (
    <AppContext.Provider value={{...value, ...defaultValue}}>
      <ColorContextProvider>
        <ColorContext.Consumer>
          {({ colors }) => {
            return <ThemeProvider theme={colors}>{children}</ThemeProvider>;
          }}
        </ColorContext.Consumer>
      </ColorContextProvider>
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { useAppContext, AppProvider };
